export var TextType;
(function (TextType) {
    TextType["title"] = "title";
    TextType["description"] = "description";
    TextType["abbr"] = "abbr";
    TextType["cti"] = "cti";
})(TextType || (TextType = {}));
export var InputType;
(function (InputType) {
    InputType["TextField"] = "TextField";
    InputType["PasswordField"] = "PasswordField";
    InputType["RetypePasswordField"] = "RetypePasswordField";
    InputType["PhysicalPropertyField"] = "PhysicalPropertyField";
    InputType["DateTimeField"] = "DateTimeField";
    InputType["TimeRangeField"] = "TimeRangeField";
    InputType["SelectField"] = "SelectField";
    InputType["CheckField"] = "CheckField";
    InputType["Hidden"] = "Hidden";
})(InputType || (InputType = {}));
//NEW since 2023-08-15
export var Operation;
(function (Operation) {
    Operation["CREATE"] = "create";
    Operation["READ"] = "read";
    Operation["UPDATE"] = "update";
})(Operation || (Operation = {}));
